const camadas = [
    {
        label: 'Agropecuária',
        chaveTraducao: 'agropecuaria',
        icon: 'mdi mdi-folder-outline',
        checkbox: false,
        id: 0,
        children: [
            {
                codigo: 'SOJA_2024_EUA',
                nome: 'Áreas Plantada Soja EUA 2024',
                label: 'Áreas Plantada Soja EUA 2024',
                checkbox: true,
                layerName: 'vega-api:soja_eua_2024',
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/gwc/service/wms',
                colorIcon: '#C1FF79',
                opacidade: 100,
                inspecionar: true
            },
            {
                codigo: 'MILHO_2024_EUA',
                nome: 'Áreas Plantada Milho EUA 2024',
                label: 'Áreas Plantada Milho EUA 2024',
                checkbox: true,
                layerName: 'vega-api:milho_eua_2024',
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/gwc/service/wms',
                colorIcon: '#ffd966',
                opacidade: 100,
                inspecionar: true
            },
            {
                codigo: 'POC_AREA_PLANTADA_GAMELEIRA',
                nome: 'Área plantada Gameleira',
                label: 'Área plantada Gameleira',
                checkbox: true,
                layerName: 'pocs:car_plantio_gameleira',
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/pocs/wms',
                colorIcon: '#6AA84F',
                opacidade: 100,
                inspecionar: true
            },
            {
                codigo: 'AREA_PLANTADA_SOJA_SAFRA_2024',
                nome: 'Área Plantada Soja - Safra 2023/2024',
                label: 'Área Plantada Soja - Safra 2023/2024',
                layerName: 'vega-api:area_plantada_soja_safra_2024',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#6aa84f',
                opacidade: 100,
                inspecionar: true
            },
            {
                codigo: 'AREA_PLANTADA_SOJA_RS_2023_2024',
                nome: 'Área Plantada Soja RS - Safra 2023/2024',
                label: 'Área Plantada Soja RS - Safra 2023/2024',
                layerName: 'vega-api:area_plantada_soja_rs_2023_2024',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#6aa84f',
                opacidade: 100,
                inspecionar: false
            },
            {
                codigo: 'AREA_PLANTADA_MILHO_RS_2023_2024',
                nome: 'Área Plantada Milho RS - Safra 2023/2024',
                label: 'Área Plantada Milho RS - Safra 2023/2024',
                layerName: 'vega-api:area_plantada_milho_rs_2023_2024',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#ffd966',
                opacidade: 100,
                inspecionar: false
            },
            {
                codigo: 'AREA_PLANTADA_SOJA_CAR_MAPBIOMAS_COLECAO9',
                nome: 'Área de soja - coleção 9 - Mapbiomas',
                label: 'Área de soja - coleção 9 - Mapbiomas',
                layerName: 'vega-api:car_area_plantada_soja_mapbiomas_colecao9',
                styleName: 'soja_mapbiomas_colecao9',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#6EBD6D',
                opacidade: 100,
                inspecionar: true
            },
            {
                codigo: 'AREA_PLANTADA_SOJA_CAR_MAPBIOMAS_COLECAO10',
                nome: 'Área de soja - coleção 10 - Mapbiomas',
                label: 'Área de soja - coleção 10 - Mapbiomas',
                layerName: 'vega-api:car_area_plantada_soja_mapbiomas_colecao10',
                styleName: 'soja_mapbiomas_colecao10',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#6EBD6D',
                opacidade: 100,
                inspecionar: true
            },
            // {
            //     codigo: 'AREA_AGRICULTAVEL',
            //     nome: 'Área agricultável',
            //     label: 'Área agricultável',
            //     layerName: 'vega-api:area_agricultavel_2023',
            //     checkbox: true,
            //     ativo: false,
            //     path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/gwc/service/wms',
            //     colorIcon: '#6AA84F',
            //     opacidade: 100,
            //     inspecionar: false
            // },
            {
                codigo: 'PLANTIO_SOJA_23_MATOPIBA',
                nome: 'Plantio de Soja Safra 22/23 – MATOPIBA',
                label: 'Plantio de Soja Safra 22/23 – MATOPIBA',
                layerName: 'vega-api:matopiba-prod',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#6aa84f',
                opacidade: 100,
                inspecionar: true
            },
            {
                codigo: 'PLANTIO_SOJA',
                nome: 'Plantio de soja',
                label: 'Plantio de soja',
                layerName: 'pocs:areas_plantio_soja_2020',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/pocs/wms',
                colorIcon: '#6aa84f',
                opacidade: 100,
                inspecionar: true
            },
            {
                codigo: 'SOJA_PARAGUAI_2022',
                nome: 'Soja (2022)',
                label: 'Soja (2022)',
                layerName: 'vega-api:soja_paraguai_2022',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#fff002',
                opacidade: 100,
                inspecionar: true
            },
            {
                codigo: 'SOJA_SAFRA_2324_MATOPIBA',
                nome: 'Área Plantada - Soja - Safra 2023/2024 - MATOPIBA',
                label: 'Área Plantada - Soja - Safra 2023/2024 - MATOPIBA',
                layerName: 'vega-api:soja_safra_2324',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#6AA84F',
                opacidade: 100,
                inspecionar: true
            },
            {
                codigo: 'SOJA_SAFRA_2324_CAR_MATOPIBA',
                nome: 'Área Plantada - Soja x CAR - Safra 2023/2024 - MATOPIBA',
                label: 'Área Plantada - Soja x CAR - Safra 2023/2024 - MATOPIBA',
                layerName: 'vega-api:soja_safra_2324_car',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#6AA84F',
                opacidade: 100,
                inspecionar: true
            },
            {
                codigo: 'SOJA_SAFRA_2425_MATOPIBA',
                nome: 'Área Plantada - Soja - Safra 2024/2025 - MATOPIBA',
                label: 'Área Plantada - Soja - Safra 2024/2025 - MATOPIBA',
                layerName: 'vega-api:area_plantada_soja_matopiba_2024_2025',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#6AA84F',
                opacidade: 100,
                inspecionar: true
            },
            {
                codigo: 'SOJA_SAFRA_2425_CAR_MATOPIBA',
                nome: 'Área Plantada - Soja x CAR - Safra 2024/2025 - MATOPIBA',
                label: 'Área Plantada - Soja x CAR - Safra 2024/2025 - MATOPIBA',
                layerName: 'vega-api:soja_safra_2425_car',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#6AA84F',
                opacidade: 100,
                inspecionar: true
            },
            {
                codigo: 'SOJA_SAFRA_2324_PARAGUAY',
                nome: 'Soja 2023/2024 - Paraguai',
                label: 'Soja 2023/2024 - Paraguai',
                layerName: 'vega-api:soja_safra_2324_paraguay',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#6aa84f',
                opacidade: 100,
                inspecionar: true
            }
        ]
    },
    {
        label: 'Cadastro Ambiental Rural',
        icon: 'mdi mdi-folder-outline',
        chaveTraducao: 'cadastroAmbientalRural',
        checkbox: false,
        id: 1,
        children: [
            {
                codigo: 'IMOVEL_RURAL',
                nome: 'CAR',
                label: 'CAR',
                layerName: 'vega-api:propriedade_rural',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#fff002',
                opacidade: 100,
                inspecionar: true,
                showOnZoom: 9
            },
            {
                codigo: 'APP',
                nome: 'Área de preservação permanente (APP)',
                label: 'Área de preservação permanente (APP)',
                layerName: 'vega-api:app',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#fff002',
                opacidade: 100,
                inspecionar: true,
                showOnZoom: 9
            },
            {
                codigo: 'RESERVA_LEGAL',
                nome: 'Reserva legal',
                label: 'Reserva legal',
                layerName: 'vega-api:reserva_legal',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#fff002',
                opacidade: 100,
                inspecionar: true,
                showOnZoom: 9
            },
            {
                codigo: 'CARS_CLASSIFICADOS',
                nome: 'Áreas classificadas do CAR',
                label: 'Áreas classificadas do CAR',
                layerName: 'vega-api:cars_classificados',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#8be365',
                opacidade: 100,
                inspecionar: false,
                subtitle: [
                    {
                        name: 'APP',
                        colorIcon: '#e4ff15',
                        opacidade: 100
                    },
                    {
                        name: 'APP a Recompor',
                        colorIcon: '#d2ac16',
                        opacidade: 100
                    },
                    {
                        name: 'Área antropizada',
                        colorIcon: '#8a8f8e',
                        opacidade: 100
                    },
                    {
                        name: 'Área consolidada',
                        colorIcon: '#616161',
                        opacidade: 100
                    },
                    {
                        name: 'Hidrografia',
                        colorIcon: '#377eb8',
                        opacidade: 100
                    },
                    {
                        name: 'Nascente',
                        colorIcon: '#0000ff',
                        opacidade: 100
                    },
                    {
                        name: 'Vegetação nativa em APP',
                        colorIcon: '#33a02c',
                        opacidade: 100
                    },
                    {
                        name: 'Vegetação nativa em RL',
                        colorIcon: '#33a02c',
                        opacidade: 100
                    }
                ]
            },
            {
                label: 'Fundiário',
                chaveTraducao: 'fundiario',
                icon: 'mdi mdi-folder-outline',
                checkbox: false,
                id: 2,
                children: [
                    {
                        codigo: 'INCRA_SIGEF_PRIVADO',
                        nome: 'INCRA/SIGEF(Privado)',
                        label: 'INCRA/SIGEF(Privado)',
                        layerName: 'vega-api:sigef_privado',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#b45f05',
                        opacidade: 100,
                        inspecionar: true,
                        showOnZoom: 9
                    },
                    {
                        codigo: 'INCRA_SIGEF_PUBLICO',
                        nome: 'INCRA/sigef (Público)',
                        label: 'INCRA/sigef (Público)',
                        layerName: 'vega-api:sigef_publico',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#9e7f05',
                        opacidade: 100,
                        inspecionar: true,
                        showOnZoom: 9
                    }
                ]
            }
        ]
    },
    {
        label: 'Conformidade socioambiental',
        chaveTraducao: 'conformidadeSocioambiental',
        icon: 'mdi mdi-folder-outline',
        checkbox: false,
        id: 3,
        children: [
            {
                codigo: 'TERRAS_INDIGENAS_EUA',
                nome: 'Terras Indígenas EUA',
                label: 'Terras Indígenas EUA',
                layerName: 'vega-api:terras_indigenas_eua',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/gwc/service/wms',
                colorIcon: '#8A4E24',
                opacidade: 100,
                inspecionar: true
            },
            {
                codigo: 'AREAS_PROTEGIDAS_EUA',
                nome: 'Áreas Protegidas EUA',
                label: 'Áreas Protegidas EUA',
                layerName: 'vega-api:areas_protegidas_eua',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/gwc/service/wms',
                colorIcon: '#FF6201',
                opacidade: 100,
                inspecionar: true
            },
            {
                codigo: 'APP_ARGENTINA_PONTOS',
                nome: 'Reservas Privadas',
                label: 'Reservas Privadas',
                layerName: 'vega-api:APP_ARGENTINA_PONTOS',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#77B26B',
                opacidade: 100,
                inspecionar: true
            },
            {
                codigo: 'APP_ARGENTINA_POLIGONOS',
                nome: 'Reservas Provinciales',
                label: 'Reservas Provinciales',
                layerName: 'vega-api:APP_ARGENTINA_POLIGONOS',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#D1EF99',
                opacidade: 100,
                inspecionar: true
            },
            {
                codigo: 'APN_AREA_MARINA_PROTEGIDA',
                nome: 'Áreas Marinas Protegidas',
                label: 'Áreas Marinas Protegidas',
                layerName: 'vega-api:APN_AREA_MARINA_PROTEGIDA',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#5967E6',
                opacidade: 100,
                inspecionar: true
            },
            {
                codigo: 'APN_SIFAP',
                nome: 'Áreas Protegidas Nacionales (APN)',
                label: 'Áreas Protegidas Nacionales (APN)',
                layerName: 'vega-api:APN_SIFAP',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#8AA97C',
                opacidade: 100,
                inspecionar: true
            },
            {
                codigo: 'APN_RESERVA_NATURAL_DEFENSA',
                nome: 'Reservas Naturales de la Defensa',
                label: 'Reservas Naturales de la Defensa',
                layerName: 'vega-api:APN_RESERVA_NATURAL_DEFENSA',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#CAA426',
                opacidade: 100,
                inspecionar: true
            },
            {
                codigo: 'APRIA_RESERVA_DE_LA_BIOSFERA',
                nome: 'Reservas de Biosfera',
                label: 'Reservas de Biosfera',
                layerName: 'vega-api:APRIA_RESERVA_DE_LA_BIOSFERA',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#F6E69B',
                opacidade: 100,
                inspecionar: true
            },
            {
                codigo: 'APRIA_PATRIMONIO_DA_HUMANIDAD_PUNTOS',
                nome: 'Sitios de Patrimonio Mundial',
                label: 'Sitios de Patrimonio Mundial',
                layerName: 'vega-api:APRIA_PATRIMONIO_DA_HUMANIDAD_PUNTOS',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#6db808',
                opacidade: 100,
                inspecionar: true
            },
            {
                codigo: 'APRIA_SITIOS_RAMSAR',
                nome: 'Sitios RAMSAR',
                label: 'Sitios RAMSAR',
                layerName: 'vega-api:APRIA_SITIOS_RAMSAR',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#55A7FE',
                opacidade: 100,
                inspecionar: true
            },
            {
                codigo: 'QUEIMADAS',
                nome: 'Queimadas',
                label: 'Queimadas',
                layerName: 'vega-api:queimadas',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#ff0000',
                opacidade: 100,
                inspecionar: true
            },
            {
                codigo: 'PROCESSOS_ATIVOS_ANM',
                nome: 'Áreas de mineração ativa',
                label: 'Áreas de mineração ativa',
                layerName: 'vega-api:processos_ativos_anm',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#ffa500',
                opacidade: 100,
                inspecionar: true
            },
            {
                codigo: 'PROCESSOS_INATIVOS_ANM',
                nome: 'Áreas de mineração inativa',
                label: 'Áreas de mineração inativa',
                layerName: 'vega-api:processos_inativos_anm',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#ffa500',
                opacidade: 100,
                inspecionar: true
            },
            {
                label: 'Embargos e Desmatamento',
                chaveTraducao: 'embargosDesmatamento',
                icon: 'mdi mdi-folder-outline',
                checkbox: false,
                id: 4,
                children: [
                    {
                        codigo: 'DESMATAMENTO_INFONA_PARAGUAI',
                        nome: 'Desmatamento INFONA',
                        label: 'Desmatamento INFONA',
                        layerName: 'vega-api:desmatamento_infona_paraguai',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#cc0000',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'AREA_EMBARGADA',
                        nome: 'Áreas Embargadas (IBAMA)',
                        label: 'Áreas Embargadas (IBAMA)',
                        layerName: 'vega-api:area_embargada',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#b21d11',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'LISTA_AREA_EMBARGADA',
                        nome: 'Áreas embargadas Ibama - Lista',
                        label: 'Áreas embargadas Ibama - Lista',
                        layerName: 'vega-api:lista_area_embargada_ibama',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#b21d11',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'AREA_EMBARGADA_SEMA_MT',
                        nome: 'Áreas Embargadas (SEMA-MT)',
                        label: 'Áreas Embargadas (SEMA-MT)',
                        layerName: 'vega-api:area_embargada_semas_mt',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#d100c5',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'AREA_EMBARGADA_SIGA_MT_POLIGONO',
                        nome: 'Áreas Embargadas (SIGA-MT)',
                        label: 'Áreas Embargadas (SIGA-MT)',
                        layerName: 'vega-api:area_embargada_siga_mt_poligono',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#70cee4',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'AREA_EMBARGADA_SIGA_MT_PONTO',
                        nome: 'Áreas Embargadas (SIGA-MT) - Ponto',
                        label: 'Áreas Embargadas (SIGA-MT) - Ponto',
                        layerName: 'vega-api:area_embargada_siga_mt_ponto',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#70cee4',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'AREA_EMBARGADA_GOIAS',
                        nome: 'Áreas Embargadas - GO',
                        label: 'Áreas Embargadas - GO',
                        layerName: 'vega-api:area_embargada_goias',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#99357B',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'AREA_EMBARGADA_PIAUI',
                        nome: 'Áreas Embargadas Piauí',
                        label: 'Áreas Embargadas Piauí',
                        layerName: 'vega-api:area_embargada_piaui',
                        checkbox: true,
                        ativo: true,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#70cee4',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'AREA_EMBARGADA_PARANA',
                        nome: 'Áreas Embargadas Paraná',
                        label: 'Áreas Embargadas Paraná',
                        layerName: 'vega-api:area_embargada_parana',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#FF0000',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'AREA_EMBARGADA_SEDAM_RO',
                        nome: 'Áreas Embargadas (SEDAM-RO)',
                        label: 'Áreas Embargadas (SEDAM-RO)',
                        layerName: 'vega-api:area_embargada_sedam_ro',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#ff0000',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'AREA_EMBARGADA_RO',
                        nome: 'Áreas Embargadas (SEDAM-RO) - Polígonos',
                        label: 'Áreas Embargadas (SEDAM-RO) - Polígonos',
                        layerName: 'vega-api:area_embargada_ro',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#ff0000',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'AREA_EMBARGADA_RO_PONTO',
                        nome: 'Áreas Embargadas (SEDAM-RO) - Pontos',
                        label: 'Áreas Embargadas (SEDAM-RO) - Pontos',
                        layerName: 'vega-api:area_embargada_ro_ponto',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#ff0000',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'AREA_EMBARGADA_ICMBIO',
                        nome: 'Área embargada ICMBio',
                        label: 'Área embargada ICMBio',
                        layerName: 'vega-api:area_embargada_icmbio',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#c0fd79',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'AREA_EMBARGADA_IBAMA_POLIGONO_PAMGIA',
                        nome: 'Área Embargada (IBAMA) - PAMGIA',
                        label: 'Área Embargada (IBAMA) - PAMGIA',
                        layerName: 'vega-api:area_embargada_ibama_poligono_pamgia',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#ff0000',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'LISTA_AREA_EMBARGADA_SEMA_MT',
                        nome: 'Lista de Áreas embargadas (SEMA-MT)',
                        label: 'Lista de Áreas embargadas (SEMA-MT)',
                        layerName: 'vega-api:area_embargada_sema_mt_lista',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#b21d19',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'PRODES',
                        nome: 'PRODES Amazônia Legal',
                        label: 'PRODES Amazônia Legal',
                        layerName: 'vega-api:prodes',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'PRODES_CERRADO',
                        nome: 'PRODES Cerrado',
                        label: 'PRODES Cerrado',
                        layerName: 'vega-api:prodes_cerrado',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'PRODES_PANTANAL',
                        nome: 'PRODES Pantanal',
                        label: 'PRODES Pantanal',
                        layerName: 'vega-api:prodes_pantanal',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'PRODES_MATA_ATLANTICA',
                        nome: 'PRODES Mata Atlântica',
                        label: 'PRODES Mata Atlântica',
                        layerName: 'vega-api:prodes_mata_atlantica',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'PRODES_PAMPA',
                        nome: 'PRODES Pampa',
                        label: 'PRODES Pampa',
                        layerName: 'vega-api:prodes_pampa',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'PRODES_CAATINGA',
                        nome: 'PRODES Caatinga',
                        label: 'PRODES Caatinga',
                        layerName: 'vega-api:prodes_caatinga',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'DESMATAMENTO_MAPBIOMAS',
                        nome: 'Desmatamento MapBiomas',
                        label: 'Desmatamento MapBiomas',
                        layerName: 'vega-api:desmatamento_mapbiomas',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#ff0000',
                        opacidade: 100,
                        inspecionar: true,
                        showOnZoom: 9
                    },
                    {
                        codigo: 'SISTEMA_ALERTAS_DESMATAMENTO_BIOMA_AMAZONIA',
                        nome: 'Sistema de alertas de desmatamento bioma Amazônia - SAD',
                        label: 'Sistema de alertas de desmatamento bioma Amazônia - SAD',
                        layerName: 'vega-api:desmatamento_mapbiomas',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#ff0000',
                        opacidade: 100,
                        inspecionar: true,
                        cql_filter: "fonte='{SAD}'"
                    },
                    {
                        codigo: 'LDI',
                        nome: 'LDI',
                        label: 'LDI',
                        layerName: 'vega-api:ldi',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#70cee4',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'DETER_AMAZONIA',
                        nome: 'DETER Amazônia Legal',
                        label: 'DETER Amazônia Legal',
                        layerName: 'vega-api:deter_amazonia',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'DETER_AMAZONIA_LEGAL_NAO_FLORESTA',
                        nome: 'DETER Amazônia Legal em Áreas de Não Floresta',
                        label: 'DETER Amazônia Legal em Áreas de Não Floresta',
                        layerName: 'vega-api:deter_amazonia_legal_nao_floresta',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'DETER_CERRADO',
                        nome: 'DETER Cerrado',
                        label: 'DETER Cerrado',
                        layerName: 'vega-api:deter_cerrado',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'DETER_PANTANAL',
                        nome: 'DETER Pantanal',
                        label: 'DETER Pantanal',
                        layerName: 'vega-api:deter_pantanal',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'MORATORIA_SOJA_PONTOS',
                        nome: 'Moratória Soja - pontos',
                        label: 'Moratória Soja - pontos',
                        layerName: 'vega-api:moratoria_soja_pontos',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#fff2cc',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'MORATORIA_SOJA',
                        nome: 'Moratória Soja - polígonos',
                        label: 'Moratória Soja - polígonos',
                        layerName: 'vega-api:moratoria_soja_poligonos',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#e19418',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'DESMATAMENTO_GFW_PARAGUAI',
                        nome: 'Desmatamento GFW Paraguai',
                        label: 'Desmatamento GFW Paraguai',
                        layerName: 'vega-api:desmatamento_gfw_paraguai',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#D100C5',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'DESMATAMENTO_VEGA_COM_SOJA_2324_VEGA_PARAGUAI',
                        nome: 'Soja 2023/2024 - Desmatamento Paraguai',
                        label: 'Soja 2023/2024 - Desmatamento Paraguai',
                        layerName: 'vega-api:desmatamento_vega_com_soja_2324_vega_paraguai',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#fff002',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'DESMATAMENTO_VEGA_2025_COM_SOJA_2425_VEGA_PARAGUAI',
                        nome: 'Soja 2024/2025 - Desmatamento Paraguai',
                        label: 'Soja 2024/2025 - Desmatamento Paraguai',
                        layerName: 'vega-api:desmatamento_vega_2025_com_soja_2425_vega_paraguai',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#fff002',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'PRODES_RESIDUOS',
                        nome: 'PRODES Resíduos Amazônia Legal',
                        label: 'PRODES Resíduos Amazônia Legal',
                        layerName: 'vega-api:prodes_residuos',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'PRODES_RESIDUOS_AMAZONIA',
                        nome: 'PRODES Resíduos Amazônia',
                        label: 'PRODES Resíduos Amazônia',
                        layerName: 'vega-api:prodes_residuos_amazonia',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'AREA_EMBARGADA_GDF',
                        nome: 'AREA_EMBARGADA_GDF',
                        label: 'Áreas Embargadas - Distrito Federal (GDF)',
                        layerName: 'vega-api:area_embargada_gdf',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#A83AEF',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'AREA_EMBARGADA_GO_PONTO',
                        nome: 'AREA_EMBARGADA_GO_PONTO',
                        label: 'Área embargada GO - Ponto',
                        layerName: 'vega-api:area_embargada_go_ponto',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#56AFCC',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'AREA_EMBARGADA_RS',
                        nome: 'AREA_EMBARGADA_RS',
                        label: 'Áreas Embargadas - RS',
                        layerName: 'vega-api:area_embargada_rs',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#DD54B6',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'PRODES_RESIDUOS_CAATINGA',
                        nome: 'PRODES Resíduos Caatinga',
                        label: 'PRODES Resíduos Caatinga',
                        layerName: 'vega-api:prodes_residuos_caatinga',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'AREA_EMBARGADA_AUTO_INFRACAO_SP',
                        nome: 'AREA_EMBARGADA_AUTO_INFRACAO_SP',
                        label: 'Áreas Embargadas - Autos de infração SP',
                        layerName: 'vega-api:area_embargada_auto_infracao_sp',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#AABDF7',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'PRODES_RESIDUOS_CERRADO',
                        nome: 'PRODES Resíduos Cerrado',
                        label: 'PRODES Resíduos Cerrado',
                        layerName: 'vega-api:prodes_residuos_cerrado',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'AUTO_INFRACAO_IPAAM',
                        nome: 'AUTO_INFRACAO_IPAAM',
                        label: 'Auto de Infração IPAAM',
                        layerName: 'vega-api:auto_de_infracao_ipaam',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#6373DC',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'PRODES_RESIDUOS_MATA_ATLANTICA',
                        nome: 'PRODES Resíduos Mata Atlântica',
                        label: 'PRODES Resíduos Mata Atlântica',
                        layerName: 'vega-api:prodes_residuos_mata_atlantica',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'AUTO_INFRACAO_TO',
                        nome: 'AUTO_INFRACAO_TO',
                        label: 'Auto de Infração - TO',
                        layerName: 'vega-api:auto_infracao_to',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#67051D',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'PRODES_RESIDUOS_PAMPA',
                        nome: 'PRODES Resíduos Pampa',
                        label: 'PRODES Resíduos Pampa',
                        layerName: 'vega-api:prodes_residuos_pampa',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'PRODES_RESIDUOS_PANTANAL',
                        nome: 'PRODES Resíduos Pantanal',
                        label: 'PRODES Resíduos Pantanal',
                        layerName: 'vega-api:prodes_residuos_pantanal',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'AREAS_EMBARGADAS_TO',
                        nome: 'AREAS_EMBARGADAS_TO',
                        label: 'Áreas Embargadas - TO',
                        layerName: 'vega-api:areas_embargadas_to',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#EF4B40',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'TERMO_EMBARGO_IPAAM',
                        nome: 'TERMO_EMBARGO_IPAAM',
                        label: 'Termo de embargo - IPAAM',
                        layerName: 'vega-api:termo_embargo_ipaam',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#A9E6B0',
                        opacidade: 100,
                        inspecionar: true
                    }
                ]
            },
            {
                label: 'Áreas protegidas',
                chaveTraducao: 'areasProtegidas',
                icon: 'mdi mdi-folder-outline',
                checkbox: false,
                id: 5,
                children: [
                    {
                        codigo: 'OTBN_ARGENTINA',
                        nome: 'Ordenamiento Territorial de Bosques Nativos (OTBN) a nivel nacional',
                        label: 'Ordenamiento Territorial de Bosques Nativos (OTBN) a nivel nacional',
                        layerName: 'vega-api:OTBN_ARGENTINA',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#8be365',
                        opacidade: 100,
                        inspecionar: true,
                        subtitle: [
                            {
                                name: 'CamI',
                                colorIcon: '#e64a1d',
                                opacidade: 100
                            },
                            {
                                name: 'CamII',
                                colorIcon: '#fcfc07',
                                opacidade: 100
                            },
                            {
                                name: 'CamIII',
                                colorIcon: '#6db808',
                                opacidade: 100
                            }

                    ]
                    },
                    {
                        codigo: 'FLORESTAS_PUBLICAS',
                        nome: 'Florestas Públicas',
                        label: 'Florestas Públicas',
                        layerName: 'vega-api:florestas_publicas',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#8be365',
                        opacidade: 100,
                        inspecionar: true,
                        subtitle: [
                            {
                                name: 'Tipo A',
                                colorIcon: '#FFA500',
                                opacidade: 100
                            },
                            {
                                name: 'Tipo B',
                                colorIcon: '#FF0000',
                                opacidade: 100
                            }

                    ]
                    },
                    {
                        codigo: 'UNIDADE_CONSERVACAO_US',
                        nome: 'Unidades de conservação de uso sustentável',
                        label: 'Unidades de conservação de uso sustentável',
                        layerName: 'vega-api:unidade_conservacao_uso_sustentavel',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#f6630b',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'UNIDADE_CONSERVACAO_PI',
                        nome: 'Unidades de conservação de proteção integral',
                        label: 'Unidades de conservação de proteção integral',
                        layerName: 'vega-api:unidade_conservacao_protecao_integral',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'ZONA_AMORTECIMENTO_UNIDADE_CONSERVACAO_PI',
                        nome: 'Zonas de amortecimento - Unidades de conservação de proteção integral',
                        label: 'Zonas de amortecimento - Unidades de conservação de proteção integral',
                        layerName: 'vega-api:zona_amortecimento_unidade_conservacao_pi',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'AREAS_SILVESTRES_PROTEGIDAS_PARAGUAI',
                        nome: 'Áreas Silvestres Protegidas do Paraguai',
                        label: 'Áreas Silvestres Protegidas do Paraguai',
                        layerName: 'vega-api:areas_protegidas_paraguai',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'AREAS_PROTEGIDAS_COM_SOJA_2324_VEGA_PARAGUAI',
                        nome: 'Soja 2023/2024 - Areas Protegidas Paraguai',
                        label: 'Soja 2023/2024 - Areas Protegidas Paraguai',
                        layerName: 'vega-api:areas_protegidas_com_soja_2324_vega_paraguai',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#CACACA',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'AREAS_PROTEGIDAS_COM_SOJA_2425_VEGA_PARAGUAI',
                        nome: 'Soja 2024/2025 - Areas Protegidas Paraguai',
                        label: 'Soja 2024/2025 - Areas Protegidas Paraguai',
                        layerName: 'vega-api:areas_protegidas_com_soja_2425_vega_paraguai',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#CACACA',
                        opacidade: 100,
                        inspecionar: true
                    }
                ]
            },
            {
                label: 'Social',
                chaveTraducao: 'social',
                icon: 'mdi mdi-folder-outline',
                checkbox: false,
                id: 6,
                children: [
                    {
                        codigo: 'TERRA_INDIGENA',
                        nome: 'Terras Indígenas',
                        label: 'Terras Indígenas',
                        layerName: 'vega-api:terra_indigena',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#e69138',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'TERRA_INDIGENA_PARAGUAI',
                        nome: 'Terras Indígenas Paraguai',
                        label: 'Terras Indígenas Paraguai',
                        layerName: 'vega-api:terra_indigena_paraguai',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#e69138',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'INCRA_QUILOMBOLAS',
                        nome: 'Comunidades quilombolas',
                        label: 'Comunidades quilombolas',
                        layerName: 'vega-api:quilombolas_incra',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#c1b0ab',
                        opacidade: 100,
                        inspecionar: true,
                        showOnZoom: 9
                    },
                    {
                        codigo: 'INCRA_ASSENTAMENTOS',
                        nome: 'Assentamento Rural',
                        label: 'Assentamento Rural',
                        layerName: 'vega-api:assentamentos',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#e5be8f',
                        opacidade: 100,
                        inspecionar: true,
                        showOnZoom: 9
                    },
                    {
                        codigo: 'SITIOS_ARQUEOLOGICOS',
                        nome: 'Sítios Arqueológicos',
                        label: 'Sítios Arqueológicos',
                        layerName: 'vega-api:sitios_arqueologicos',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#b9770e',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'TERRA_INDIGENA_COM_SOJA_2324_VEGA_PARAGUAI',
                        nome: 'Soja 2023/2024 - Terras Indígenas Paraguai',
                        label: 'Soja 2023/2024 - Terras Indígenas Paraguai',
                        layerName: 'vega-api:terra_indigena_com_soja_2324_vega_paraguai',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#F69F8C',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'TERRA_INDIGENA_COM_SOJA_2425_VEGA_PARAGUAI',
                        nome: 'Soja 2024/2025 - Terras Indígenas Paraguai',
                        label: 'Soja 2024/2025 - Terras Indígenas Paraguai',
                        layerName: 'vega-api:terra_indigena_com_soja_2425_vega_paraguai',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#F69F8C',
                        opacidade: 100,
                        inspecionar: true
                    }
                ]
            }
        ]
    },
    {
        label: 'Limites territoriais',
        chaveTraducao: 'limitesTerritoriais',
        icon: 'mdi mdi-folder-outline',
        checkbox: false,
        id: 7,
        children: [
            {
                label: 'Áreas administrativas',
                chaveTraducao: 'areasAdministrativas',
                icon: 'mdi mdi-folder-outline',
                checkbox: false,
                id: 8,
                children: [
                    {
                        codigo: 'BIOMAS',
                        nome: 'Biomas',
                        label: 'Biomas',
                        layerName: 'vega-api:biomas',
                        styleName: 'vega-api:biomas-classificados',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/gwc/service/wms',
                        colorIcon: '#8be365',
                        opacidade: 100,
                        inspecionar: true,
                        subtitle: [
                                    {
                                        name: 'Amazonia',
                                        colorIcon: '#42a72a',
                                        opacidade: 100
                                    },
                                    {
                                        name: 'Cerrado',
                                        colorIcon: '#fde8a0',
                                        opacidade: 100
                                    },
                                    {
                                        name: 'Caatinga',
                                        colorIcon: '#f69f8c',
                                        opacidade: 100
                                    },
                                    {
                                        name: 'Pantanal',
                                        colorIcon: '#a3a189',
                                        opacidade: 100
                                    },
                                    {
                                        name: 'Mata Atlântica',
                                        colorIcon: '#fbe1fe',
                                        opacidade: 100
                                    },
                                    {
                                        name: 'Pampa',
                                        colorIcon: '#d3ecb5',
                                        opacidade: 100
                                    }
                            ]
                    },
                    {
                        codigo: 'FAIXA_FRONTEIRA',
                        nome: 'Faixa de fronteira',
                        label: 'Faixa de fronteira',
                        layerName: 'vega-api:faixa_fronteira',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/gwc/service/wms',
                        colorIcon: '#E06666',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'BR_LOCALIDADE_NIVEL_1',
                        nome: 'Estados',
                        label: 'Estados',
                        layerName: 'vega-api:br_localidade_nivel_1',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/gwc/service/wms',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'BR_LOCALIDADE_NIVEL_2',
                        nome: 'Municípios',
                        label: 'Municípios',
                        layerName: 'vega-api:br_localidade_nivel_2',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/gwc/service/wms',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'PY_LOCALIDADE_NIVEL_1',
                        nome: 'Departamentos Paraguai',
                        label: 'Departamentos Paraguai',
                        layerName: 'vega-api:py_localidade_nivel_1',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/gwc/service/wms',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'PY_LOCALIDADE_NIVEL_2',
                        nome: 'Distritos Paraguai',
                        label: 'Distritos Paraguai',
                        layerName: 'vega-api:py_localidade_nivel_2',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/gwc/service/wms',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'AR_LOCALIDADE_NIVEL_1',
                        nome: 'Provincias Argentina',
                        label: 'Provincias Argentina',
                        layerName: 'vega-api:ar_localidade_nivel_1',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/gwc/service/wms',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'AR_LOCALIDADE_NIVEL_2',
                        nome: 'Departamentos Argentina',
                        label: 'Departamentos Argentina',
                        layerName: 'vega-api:ar_localidade_nivel_2',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/gwc/service/wms',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'TERRITORIOS',
                        nome: 'Territórios',
                        label: 'Territórios',
                        layerName: process.env.VUE_APP_LAYER_TERRITORIO + ':territorio',
                        checkbox: true,
                        ativo: false,
                        local: true,
                        path: process.env.VUE_APP_LAYER_TERRITORIO + '/wms',
                        colorIcon: '#0bfb00',
                        opacidade: 100
                    }
                ]
            }
        ]
    },
    {
        label: 'Recursos naturais',
        chaveTraducao: 'recursosNaturais',
        icon: 'mdi mdi-folder-outline',
        checkbox: false,
        id: 9,
        children: [
            {
                codigo: 'PASTAGEM_EUA_2007',
                nome: 'Pastagem 2007 EUA',
                label: 'Pastagem 2007 EUA',
                checkbox: true,
                layerName: 'vega-api:pastagem_2007_eua',
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/gwc/service/wms',
                colorIcon: '#93c47d',
                opacidade: 100,
                inspecionar: true
            },
            {
                codigo: 'FLORESTA_NATURAL_EUA_2007',
                nome: 'Floresta Natural 2007 EUA',
                label: 'Floresta Natural 2007 EUA',
                checkbox: true,
                layerName: 'vega-api:floresta_natural_2007_eua',
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/gwc/service/wms',
                colorIcon: '#38761d',
                opacidade: 100,
                inspecionar: true
            },
            {
                codigo: 'TURFA_EUA',
                nome: 'Áreas de Turfa 2022 EUA',
                label: 'Áreas de Turfa 2022 EUA',
                checkbox: true,
                layerName: 'vega-api:turfa_eua_2022',
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/gwc/service/wms',
                colorIcon: '#f1c232',
                opacidade: 100,
                inspecionar: true
            },
            {
                codigo: 'AREA_UMIDA_EUA',
                nome: 'Wetlands',
                label: 'Wetlands',
                checkbox: true,
                layerName: 'vega-api:areas_umidas_eua',
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/gwc/service/wms',
                colorIcon: '#02fab0',
                opacidade: 100,
                inspecionar: true
            },
            {
                codigo: 'USO_DEL_SUELO_2007_ARGENTINA',
                nome: 'Uso del Suelo 2007',
                label: 'Uso del Suelo 2007',
                layerName: 'vega-api:Uso_Del_Suelo_Argentina_2007',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/ows',
                colorIcon: '#8be365',
                opacidade: 100,
                inspecionar: false,
                subtitle: [
                            {
                                name: 'Agua',
                                colorIcon: '#0000ff',
                                opacidade: 100
                            },
                            {
                                name: 'Suelo',
                                colorIcon: '#ffa500',
                                opacidade: 100
                            },
                            {
                                name: 'Pastizal',
                                colorIcon: '#7fff00',
                                opacidade: 100
                            },
                            {
                                name: 'Cultivo',
                                colorIcon: '#ffff00',
                                opacidade: 100
                            },
                            {
                                name: 'Florestal',
                                colorIcon: '#006400',
                                opacidade: 100
                            },
                            {
                                name: 'Urbano',
                                colorIcon: '#ff0000',
                                opacidade: 100
                            }
                    ]
            },
            {
                codigo: 'USO_DEL_SUELO_2020_ARGENTINA',
                nome: 'Uso del Suelo 2020',
                label: 'Uso del Suelo 2020',
                layerName: 'vega-api:Uso_Del_Suelo_Argentina_2020',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/ows',
                colorIcon: '#8be365',
                opacidade: 100,
                inspecionar: false,
                subtitle: [
                            {
                                name: 'Agua',
                                colorIcon: '#0000ff',
                                opacidade: 100
                            },
                            {
                                name: 'Suelo',
                                colorIcon: '#ffa500',
                                opacidade: 100
                            },
                            {
                                name: 'Pastizal',
                                colorIcon: '#7fff00',
                                opacidade: 100
                            },
                            {
                                name: 'Cultivo',
                                colorIcon: '#ffff00',
                                opacidade: 100
                            },
                            {
                                name: 'Florestal',
                                colorIcon: '#006400',
                                opacidade: 100
                            },
                            {
                                name: 'Urbano',
                                colorIcon: '#ff0000',
                                opacidade: 100
                            }
                    ]
            },
            {
                codigo: 'USO_DEL_SUELO_2024_ARGENTINA',
                nome: 'Uso del Suelo 2024',
                label: 'Uso del Suelo 2024',
                layerName: 'vega-api:Uso_Del_Suelo_Argentina_2024',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/ows',
                colorIcon: '#8be365',
                opacidade: 100,
                inspecionar: false,
                subtitle: [
                            {
                                name: 'Agua',
                                colorIcon: '#0000ff',
                                opacidade: 100
                            },
                            {
                                name: 'Suelo',
                                colorIcon: '#ffa500',
                                opacidade: 100
                            },
                            {
                                name: 'Pastizal',
                                colorIcon: '#7fff00',
                                opacidade: 100
                            },
                            {
                                name: 'Cultivo',
                                colorIcon: '#ffff00',
                                opacidade: 100
                            },
                            {
                                name: 'Florestal',
                                colorIcon: '#006400',
                                opacidade: 100
                            },
                            {
                                name: 'Urbano',
                                colorIcon: '#ff0000',
                                opacidade: 100
                            }
                    ]
            },
            {
                codigo: 'BOSQUE_NATIVO_PARAGUAI',
                nome: 'Bosque Nativo',
                label: 'Bosque Nativo',
                layerName: 'vega-api:bosque_nativo_paraguai',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#c1ff79',
                opacidade: 100,
                inspecionar: true
            },
            {
                codigo: 'PALMAR_PARAGUAI',
                nome: 'Palmar',
                label: 'Palmar',
                layerName: 'vega-api:palmar_paraguai',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#fbe1fe',
                opacidade: 100,
                inspecionar: true
            },
            {
                codigo: 'SOLOS_ARGENTINA',
                nome: 'Mapa del suelo ARG',
                label: 'Mapa del suelo ARG',
                layerName: 'vega-api:tipos_de_solos',
                styleName: 'vega-api:mapa_solo_arg',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/gwc/service/wms',
                colorIcon: '#8be365',
                opacidade: 100,
                inspecionar: true,
                subtitle: [
                    {
                        name: 'Alfisoles',
                        colorIcon: '#429CD1',
                        opacidade: 100
                    },
                    {
                        name: 'Andisoles',
                        colorIcon: '#ABAA02',
                        opacidade: 100
                    },
                    {
                        name: 'Aridisoles',
                        colorIcon: '#B2494D',
                        opacidade: 100
                    },
                    {
                        name: 'Entisoles',
                        colorIcon: '#FFD67C',
                        opacidade: 100
                    },
                    {
                        name: 'Histosoles',
                        colorIcon: '#FF9A00',
                        opacidade: 100
                    },
                    {
                        name: 'Inceptisoles',
                        colorIcon: '#6054D9',
                        opacidade: 100
                    },
                    {
                        name: 'Molisoles',
                        colorIcon: '#BE67D2',
                        opacidade: 100
                    },
                    {
                        name: 'Oxisoles',
                        colorIcon: '#BD65D1',
                        opacidade: 100
                    },
                    {
                        name: 'Spodosoles',
                        colorIcon: '#DE399F',
                        opacidade: 100
                    },
                    {
                        name: 'Ultisoles',
                        colorIcon: '#FF4D05',
                        opacidade: 100
                    },
                    {
                        name: 'Vertisoles',
                        colorIcon: '#FFA47D',
                        opacidade: 100
                    },
                    {
                        name: 'No clasificado',
                        colorIcon: '#949494',
                        opacidade: 100
                    }
                ]
            },
            {
                codigo: 'SOLOS_EMBRAPA_BRASIL',
                nome: 'Mapa de solo BR',
                label: 'Mapa de solo BR',
                layerName: 'vega-api:solos_embrapa_brasil',
                styleName: 'vega-api:mapa_solo_br',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/gwc/service/wms',
                colorIcon: '#8be365',
                opacidade: 100,
                inspecionar: true,
                subtitle: [
                    {
                        name: 'AC',
                        colorIcon: '#CF832D',
                        opacidade: 100
                    },
                    {
                        name: 'AR',
                        colorIcon: '#EDCFB7',
                        opacidade: 100
                    },
                    {
                        name: 'CH',
                        colorIcon: '#B37757',
                        opacidade: 100
                    },
                    {
                        name: 'CX',
                        colorIcon: '#D6AF6F',
                        opacidade: 100
                    },
                    {
                        name: 'DN',
                        colorIcon: '#F79963',
                        opacidade: 100
                    },
                    {
                        name: 'ES',
                        colorIcon: '#B39B7D',
                        opacidade: 100
                    },
                    {
                        name: 'FF',
                        colorIcon: '#E66E32',
                        opacidade: 100
                    },
                    {
                        name: 'FX',
                        colorIcon: '#F0AE51',
                        opacidade: 100
                    },
                    {
                        name: 'GJ',
                        colorIcon: '#B35F2E',
                        opacidade: 100
                    },
                    {
                        name: 'GX',
                        colorIcon: '#BA8345',
                        opacidade: 100
                    },
                    {
                        name: 'GZ',
                        colorIcon: '#E3A47F',
                        opacidade: 100
                    },
                    {
                        name: 'LA',
                        colorIcon: '#FAD0A0',
                        opacidade: 100
                    },
                    {
                        name: 'LB',
                        colorIcon: '#FAB039',
                        opacidade: 100
                    },
                    {
                        name: 'LV',
                        colorIcon: '#E88543',
                        opacidade: 100
                    },
                    {
                        name: 'LVA',
                        colorIcon: '#DB9F5A',
                        opacidade: 100
                    },
                    {
                        name: 'MD',
                        colorIcon: '#C47947',
                        opacidade: 100
                    },
                    {
                        name: 'ME',
                        colorIcon: '#D4AE96',
                        opacidade: 100
                    },
                    {
                        name: 'MT',
                        colorIcon: '#B58E62',
                        opacidade: 100
                    },
                    {
                        name: 'Massa dagua',
                        colorIcon: '#97DBF2',
                        opacidade: 100
                    },
                    {
                        name: 'NV',
                        colorIcon: '#D4B587',
                        opacidade: 100
                    },
                    {
                        name: 'NX',
                        colorIcon: '#BF8A34',
                        opacidade: 100
                    },
                    {
                        name: 'OY',
                        colorIcon: '#F7BD9C',
                        opacidade: 100
                    },
                    {
                        name: 'PA',
                        colorIcon: '#FABA82',
                        opacidade: 100
                    },
                    {
                        name: 'PAC',
                        colorIcon: '#B39B8F',
                        opacidade: 100
                    },
                    {
                        name: 'PV',
                        colorIcon: '#F09841',
                        opacidade: 100
                    },
                    {
                        name: 'PVA',
                        colorIcon: '#B58A72',
                        opacidade: 100
                    },
                    {
                        name: 'RL',
                        colorIcon: '#C4702F',
                        opacidade: 100
                    },
                    {
                        name: 'RQ',
                        colorIcon: '#B87830',
                        opacidade: 100
                    },
                    {
                        name: 'RR',
                        colorIcon: '#F0C073',
                        opacidade: 100
                    },
                    {
                        name: 'RU',
                        colorIcon: '#C25C29',
                        opacidade: 100
                    },
                    {
                        name: 'SG',
                        colorIcon: '#F5A95D',
                        opacidade: 100
                    },
                    {
                        name: 'SN',
                        colorIcon: '#E38556',
                        opacidade: 100
                    },
                    {
                        name: 'SX',
                        colorIcon: '#FAE2BE',
                        opacidade: 100
                    },
                    {
                        name: 'TC',
                        colorIcon: '#CCB89B',
                        opacidade: 100
                    },
                    {
                        name: 'VC',
                        colorIcon: '#D19D69',
                        opacidade: 100
                    },
                    {
                        name: 'VE',
                        colorIcon: '#E39649',
                        opacidade: 100
                    },
                    {
                        name: 'VG',
                        colorIcon: '#D47542',
                        opacidade: 100
                    }
                ]
            },
            {
                codigo: 'COBERTURA_SOLO_MAPBIOMAS',
                nome: 'Cobertura do Solo - Mapbiomas (coleção 8)',
                label: 'Cobertura do Solo - Mapbiomas (coleção 8)',
                layerName: 'vega-api:cobertura_solo_map_biomas_2022',
                styleName: 'vega-api:cobertura_solo_mapbiomas_colecao8',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/gwc/service/wms',
                colorIcon: '#8be365',
                opacidade: 100,
                inspecionar: false,
                showOnZoom: 9,
                subtitle: [
                    {
                        name: 'Afloramento Rochoso',
                        colorIcon: '#FF8C00',
                        opacidade: 100
                    },
                    {
                        name: 'Agricultura',
                        colorIcon: '#E974ED',
                        opacidade: 100
                    },
                    {
                        name: 'Algodão beta',
                        colorIcon: '#660066',
                        opacidade: 100
                    },
                    {
                        name: 'Apicum',
                        colorIcon: '#968C46',
                        opacidade: 100
                    },
                    {
                        name: 'Aquicultura',
                        colorIcon: '#29EEE4',
                        opacidade: 100
                    },
                    {
                        name: 'Área Urbanizada',
                        colorIcon: '#AF2A2A',
                        opacidade: 100
                    },
                    {
                        name: 'Arroz',
                        colorIcon: '#982C9E',
                        opacidade: 100
                    },
                    {
                        name: 'Café',
                        colorIcon: '#CCA0D4',
                        opacidade: 100
                    },
                    {
                        name: 'Citrus',
                        colorIcon: '#D082DE',
                        opacidade: 100
                    },
                    {
                        name: 'Campo Alagado e Área Pantanosa',
                        colorIcon: '#45C2A5',
                        opacidade: 100
                    },
                    {
                        name: 'Cana',
                        colorIcon: '#C27BA0',
                        opacidade: 100
                    },
                    {
                        name: 'Formação Campestre',
                        colorIcon: '#B8AF4F',
                        opacidade: 100
                    },
                    {
                        name: 'Formação Florestal',
                        colorIcon: '#006400',
                        opacidade: 100
                    },
                    {
                        name: 'Formação Savânica',
                        colorIcon: '#32CD32',
                        opacidade: 100
                    },
                    {
                        name: 'Lavoura Perene',
                        colorIcon: '#F3B4F1',
                        opacidade: 100
                    },
                    {
                        name: 'Lavoura Temporária',
                        colorIcon: '#D5A6BD',
                        opacidade: 100
                    },
                    {
                        name: 'Mangue',
                        colorIcon: '#687537',
                        opacidade: 100
                    },
                    {
                        name: 'Mineração',
                        colorIcon: '#8A2BE2',
                        opacidade: 100
                    },
                    {
                        name: 'Mosaico de Usos',
                        colorIcon: '#FFEFC3',
                        opacidade: 100
                    },
                    {
                        name: 'Outras Áreas não Vegetadas',
                        colorIcon: '#FF99FF',
                        opacidade: 100
                    },
                    {
                        name: 'Outras Formações não Florestais',
                        colorIcon: '#BDB76B',
                        opacidade: 100
                    },
                    {
                        name: 'Outras Lavouras Perenes',
                        colorIcon: '#CD49E4',
                        opacidade: 100
                    },
                    {
                        name: 'Outras Lavouras Temporárias',
                        colorIcon: '#E787F8',
                        opacidade: 100
                    },
                    {
                        name: 'Pastagem',
                        colorIcon: '#FFD966',
                        opacidade: 100
                    },
                    {
                        name: 'Praia Duna e Areal',
                        colorIcon: '#DD7E6B',
                        opacidade: 100
                    },
                    {
                        name: 'Restinga Arborizada',
                        colorIcon: '#6B9932',
                        opacidade: 100
                    },
                    {
                        name: 'Restinga Herbácea',
                        colorIcon: '#66FFCC',
                        opacidade: 100
                    },
                    {
                        name: 'Rio Lago e Oceano',
                        colorIcon: '#0000FF',
                        opacidade: 100
                    },
                    {
                        name: 'Silvicultura monocultura',
                        colorIcon: '#935132',
                        opacidade: 100
                    },
                    {
                        name: 'Soja',
                        colorIcon: '#C59FF4',
                        opacidade: 100
                    }
                ]
            },
            {
                codigo: 'COBERTURA_SOLO_MAPBIOMAS_2023',
                nome: 'Cobertura do Solo - Mapbiomas (coleção 9)',
                label: 'Cobertura do Solo - Mapbiomas (coleção 9)',
                layerName: 'vega-api:cobertura_solo_map_biomas_2023',
                styleName: 'vega-api:cobertura_solo_mapbiomas_colecao9',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#8be365',
                opacidade: 100,
                inspecionar: false,
                showOnZoom: 9,
                subtitle: [
                    {
                        name: 'Floresta',
                        colorIcon: '#1f8d49',
                        opacidade: 100
                    },
                    {
                        name: 'Formação Florestal',
                        colorIcon: '#1f8d49',
                        opacidade: 100
                    },
                    {
                        name: 'Formação Savânica',
                        colorIcon: '#7dc975',
                        opacidade: 100
                    },
                    {
                        name: 'Mangue',
                        colorIcon: '#04381d',
                        opacidade: 100
                    },
                    {
                        name: 'Floresta Alagável',
                        colorIcon: '#007785',
                        opacidade: 100
                    },
                    {
                        name: 'Restinga Arbórea',
                        colorIcon: '#02d659',
                        opacidade: 100
                    },
                    {
                        name: 'Vegetação Herbácea e Arbustiva',
                        colorIcon: '#d6bc74',
                        opacidade: 100
                    },
                    {
                        name: 'Campo Alagado e Área Pantanosa',
                        colorIcon: '#519799',
                        opacidade: 100
                    },
                    {
                        name: 'Formação Campestre',
                        colorIcon: '#d6bc74',
                        opacidade: 100
                    },
                    {
                        name: 'Apicum',
                        colorIcon: '#fc8114',
                        opacidade: 100
                    },
                    {
                        name: 'Afloramento Rochoso',
                        colorIcon: '#ffaa5f',
                        opacidade: 100
                    },
                    {
                        name: 'Restinga Herbácea',
                        colorIcon: '#ad5100',
                        opacidade: 100
                    },
                    {
                        name: 'Agropecuária',
                        colorIcon: '#ffefc3',
                        opacidade: 100
                    },
                    {
                        name: 'Pastagem',
                        colorIcon: '#edde8e',
                        opacidade: 100
                    },
                    {
                        name: 'Agricultura',
                        colorIcon: '#E974ED',
                        opacidade: 100
                    },
                    {
                        name: 'Lavoura Temporária',
                        colorIcon: '#C27BA0',
                        opacidade: 100
                    },
                    {
                        name: 'Soja',
                        colorIcon: '#f5b3c8',
                        opacidade: 100
                    },
                    {
                        name: 'Cana',
                        colorIcon: '#db7093',
                        opacidade: 100
                    },
                    {
                        name: 'Arroz',
                        colorIcon: '#c71585',
                        opacidade: 100
                    },
                    {
                        name: 'Algodão (beta)',
                        colorIcon: '#ff69b4',
                        opacidade: 100
                    },
                    {
                        name: 'Outras Lavouras Temporárias',
                        colorIcon: '#f54ca9',
                        opacidade: 100
                    },
                    {
                        name: 'Lavoura Perene',
                        colorIcon: '#d082de',
                        opacidade: 100
                    },
                    {
                        name: 'Café',
                        colorIcon: '#d68fe2',
                        opacidade: 100
                    },
                    {
                        name: 'Citrus',
                        colorIcon: '#9932cc',
                        opacidade: 100
                    },
                    {
                        name: 'Dendê',
                        colorIcon: '#9065d0',
                        opacidade: 100
                    },
                    {
                        name: 'Outras Lavouras Perenes',
                        colorIcon: '#e6ccff',
                        opacidade: 100
                    },
                    {
                        name: 'Silvicultura',
                        colorIcon: '#7a5900',
                        opacidade: 100
                    },
                    {
                        name: 'Mosaico de Usos',
                        colorIcon: '#ffefc3',
                        opacidade: 100
                    },
                    {
                        name: 'Área não Vegetada',
                        colorIcon: '#d4271e',
                        opacidade: 100
                    },
                    {
                        name: 'Praia Duna e Areal',
                        colorIcon: '#ffa07a',
                        opacidade: 100
                    },
                    {
                        name: 'Área Urbanizada',
                        colorIcon: '#d4271e',
                        opacidade: 100
                    },
                    {
                        name: 'Mineração',
                        colorIcon: '#9c0027',
                        opacidade: 100
                    },
                    {
                        name: 'Outras Áreas não Vegetadas',
                        colorIcon: '#db4d4f',
                        opacidade: 100
                    },
                    {
                        name: 'Corpo Dágua',
                        colorIcon: '#2532e4',
                        opacidade: 100
                    },
                    {
                        name: 'Rio Lago e Oceano',
                        colorIcon: '#2532e4',
                        opacidade: 100
                    },
                    {
                        name: 'Aquicultura',
                        colorIcon: '#091077',
                        opacidade: 100
                    },
                    {
                        name: 'Não observado',
                        colorIcon: '#ffffff',
                        opacidade: 100
                    }
                ]
            },
            {
                codigo: 'COBERTURA_SOLO_MAPBIOMAS_2024',
                nome: 'Cobertura do Solo - Mapbiomas (coleção 10)',
                label: 'Cobertura do Solo - Mapbiomas (coleção 10)',
                layerName: 'vega-api:cobertura_solo_map_biomas_2024',
                styleName: 'vega-api:cobertura_solo_mapbiomas_colecao10',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#8be365',
                opacidade: 100,
                inspecionar: false,
                showOnZoom: 9,
                subtitle: [
                    {
                        name: 'Floresta',
                        colorIcon: '#1f8d49',
                        opacidade: 100
                    },
                    {
                        name: 'Formação Florestal',
                        colorIcon: '#1f8d49',
                        opacidade: 100
                    },
                    {
                        name: 'Formação Savânica',
                        colorIcon: '#7dc975',
                        opacidade: 100
                    },
                    {
                        name: 'Mangue',
                        colorIcon: '#04381d',
                        opacidade: 100
                    },
                    {
                        name: 'Floresta Alagável',
                        colorIcon: '#007785',
                        opacidade: 100
                    },
                    {
                        name: 'Restinga Arbórea',
                        colorIcon: '#02d659',
                        opacidade: 100
                    },
                    {
                        name: 'Vegetação Herbácea e Arbustiva',
                        colorIcon: '#d6bc74',
                        opacidade: 100
                    },
                    {
                        name: 'Campo Alagado e Área Pantanosa',
                        colorIcon: '#519799',
                        opacidade: 100
                    },
                    {
                        name: 'Formação Campestre',
                        colorIcon: '#d6bc74',
                        opacidade: 100
                    },
                    {
                        name: 'Apicum',
                        colorIcon: '#fc8114',
                        opacidade: 100
                    },
                    {
                        name: 'Afloramento Rochoso',
                        colorIcon: '#ffaa5f',
                        opacidade: 100
                    },
                    {
                        name: 'Restinga Herbácea',
                        colorIcon: '#ad5100',
                        opacidade: 100
                    },
                    {
                        name: 'Agropecuária',
                        colorIcon: '#ffefc3',
                        opacidade: 100
                    },
                    {
                        name: 'Pastagem',
                        colorIcon: '#edde8e',
                        opacidade: 100
                    },
                    {
                        name: 'Agricultura',
                        colorIcon: '#E974ED',
                        opacidade: 100
                    },
                    {
                        name: 'Lavoura Temporária',
                        colorIcon: '#C27BA0',
                        opacidade: 100
                    },
                    {
                        name: 'Soja',
                        colorIcon: '#f5b3c8',
                        opacidade: 100
                    },
                    {
                        name: 'Cana',
                        colorIcon: '#db7093',
                        opacidade: 100
                    },
                    {
                        name: 'Arroz',
                        colorIcon: '#c71585',
                        opacidade: 100
                    },
                    {
                        name: 'Algodão (beta)',
                        colorIcon: '#ff69b4',
                        opacidade: 100
                    },
                    {
                        name: 'Outras Lavouras Temporárias',
                        colorIcon: '#f54ca9',
                        opacidade: 100
                    },
                    {
                        name: 'Lavoura Perene',
                        colorIcon: '#d082de',
                        opacidade: 100
                    },
                    {
                        name: 'Café',
                        colorIcon: '#d68fe2',
                        opacidade: 100
                    },
                    {
                        name: 'Citrus',
                        colorIcon: '#9932cc',
                        opacidade: 100
                    },
                    {
                        name: 'Dendê',
                        colorIcon: '#9065d0',
                        opacidade: 100
                    },
                    {
                        name: 'Outras Lavouras Perenes',
                        colorIcon: '#e6ccff',
                        opacidade: 100
                    },
                    {
                        name: 'Silvicultura',
                        colorIcon: '#7a5900',
                        opacidade: 100
                    },
                    {
                        name: 'Mosaico de Usos',
                        colorIcon: '#ffefc3',
                        opacidade: 100
                    },
                    {
                        name: 'Área não Vegetada',
                        colorIcon: '#d4271e',
                        opacidade: 100
                    },
                    {
                        name: 'Praia Duna e Areal',
                        colorIcon: '#ffa07a',
                        opacidade: 100
                    },
                    {
                        name: 'Área Urbanizada',
                        colorIcon: '#d4271e',
                        opacidade: 100
                    },
                    {
                        name: 'Mineração',
                        colorIcon: '#9c0027',
                        opacidade: 100
                    },
                    {
                        name: 'Outras Áreas não Vegetadas',
                        colorIcon: '#db4d4f',
                        opacidade: 100
                    },
                    {
                        name: 'Corpo Dágua',
                        colorIcon: '#2532e4',
                        opacidade: 100
                    },
                    {
                        name: 'Rio Lago e Oceano',
                        colorIcon: '#2532e4',
                        opacidade: 100
                    },
                    {
                        name: 'Aquicultura',
                        colorIcon: '#091077',
                        opacidade: 100
                    },
                    {
                        name: 'Não observado',
                        colorIcon: '#ffffff',
                        opacidade: 100
                    }
                ]
            },
            {
                codigo: 'LANDUSE_RS_2024',
                nome: 'Uso do solo RS (2024)',
                label: 'Uso do solo RS (2024)',
                layerName: 'vega-api:landuse_rs_2024',
                styleName: 'vega-api:landuse_rs_2024',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#8be365',
                opacidade: 100,
                inspecionar: false,
                showOnZoom: 9,
                subtitle: [
                    {
                        name: 'Corpo DÁgua',
                        colorIcon: '#00C5FF',
                        opacidade: 100
                    },
                    {
                        name: 'Vegetação Nativa',
                        colorIcon: '#267300',
                        opacidade: 100
                    },
                    {
                        name: 'Pastagem',
                        colorIcon: '#FFFFBE',
                        opacidade: 100
                    },
                    {
                        name: 'Agricultura Temporária',
                        colorIcon: '#FFAA00',
                        opacidade: 100
                    },
                    {
                        name: 'Agricultura Semiperene',
                        colorIcon: '#00FC22',
                        opacidade: 100
                    },
                    {
                        name: 'Agricultura Perene',
                        colorIcon: '#A87000',
                        opacidade: 100
                    },
                    {
                        name: 'Silvicultura',
                        colorIcon: '#730000',
                        opacidade: 100
                    },
                    {
                        name: 'Solo Exposto',
                        colorIcon: '#FF00C5',
                        opacidade: 100
                    },
                    {
                        name: 'Áreas Construídas',
                        colorIcon: '#4E4E4E',
                        opacidade: 100
                    },
                    {
                        name: 'Não observado',
                        colorIcon: '#ffffff',
                        opacidade: 100
                    }
                ]
            },
            {
                codigo: 'CARS_DECLARADOS',
                nome: 'Áreas declaradas do CAR',
                label: 'Áreas declaradas do CAR',
                layerName: 'vega-api:cars_declarados',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#8be365',
                opacidade: 100,
                inspecionar: false,
                subtitle: [
                    {
                        name: 'APP Total',
                        colorIcon: '#e4ff15',
                        opacidade: 100
                    },
                    {
                        name: 'Área Consolidada',
                        colorIcon: '#616161',
                        opacidade: 100
                    },
                    {
                        name: 'Área Não Classificada',
                        colorIcon: '#ebf0dc',
                        opacidade: 100
                    },
                    {
                        name: 'Hidrografia',
                        colorIcon: '#377eb8',
                        opacidade: 100
                    },
                    {
                        name: "Nascente ou olho d'água perene",
                        colorIcon: '#0000ff',
                        opacidade: 100
                    },
                    {
                        name: 'Vegetação Nativa',
                        colorIcon: '#33a02c',
                        opacidade: 100
                    },
                    {
                        name: 'Reserva Legal',
                        colorIcon: '#4d654a',
                        opacidade: 100
                    }
                ]
            }
        ]
    },
    {
        label: 'Certificações',
        chaveTraducao: 'certificacoes',
        icon: 'mdi mdi-folder-outline',
        checkbox: false,
        id: 10,
        children: [
            {
                label: 'Renovabio',
                chaveTraducao: 'renovabio',
                icon: 'mdi mdi-folder-outline',
                checkbox: false,
                id: 11,
                children: [
                    {
                        codigo: 'ELEGIBILIDADE_RENOVABIO_ELEGIVEL_RS_2024',
                        nome: 'CARs Elegíveis - RS',
                        label: 'CARs Elegíveis - RS',
                        layerName: 'vega-api:elegibilidade_renovabio_elegivel_rs_2024',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#9ef42f',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'ELEGIBILIDADE_RENOVABIO_NAO_ELEGIVEL_RS_2024',
                        nome: 'CARs Inelegíveis - RS',
                        label: 'CARs Inelegíveis - RS',
                        layerName: 'vega-api:elegibilidade_renovabio_nao_elegivel_rs_2024',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#f45f2f',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'ELEGIBILIDADE_RENOVABIO_ELEGIVEL_RS_2023',
                        nome: 'CARs Elegíveis - RS',
                        label: 'CARs Elegíveis - RS',
                        layerName: 'vega-api:elegibilidade_renovabio_elegivel_rs_2023',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#9ef42f',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'ELEGIBILIDADE_RENOVABIO_NAO_ELEGIVEL_RS_2023',
                        nome: 'CARs Inelegíveis - RS',
                        label: 'CARs Inelegíveis - RS',
                        layerName: 'vega-api:elegibilidade_renovabio_nao_elegivel_rs_2023',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#f45f2f',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'ELEGIBILIDADE_RENOVABIO_ELEGIVEL_RS_2022',
                        nome: 'CARs Elegíveis - RS',
                        label: 'CARs Elegíveis - RS',
                        layerName: 'vega-api:elegibilidade_renovabio_elegivel_rs_2022',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#9ef42f',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'ELEGIBILIDADE_RENOVABIO_NAO_ELEGIVEL_RS_2022',
                        nome: 'CARs Inelegíveis - RS',
                        label: 'CARs Inelegíveis - RS',
                        layerName: 'vega-api:elegibilidade_renovabio_nao_elegivel_rs_2022',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#f45f2f',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'ELEGIBILIDADE_RENOVABIO_ELEGIVEL_RS_2021',
                        nome: 'CARs Elegíveis - RS',
                        label: 'CARs Elegíveis - RS',
                        layerName: 'vega-api:elegibilidade_renovabio_elegivel_rs_2021',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#9ef42f',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'ELEGIBILIDADE_RENOVABIO_NAO_ELEGIVEL_RS_2021',
                        nome: 'CARs Inelegíveis - RS',
                        label: 'CARs Inelegíveis - RS',
                        layerName: 'vega-api:elegibilidade_renovabio_nao_elegivel_rs_2021',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#f45f2f',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'ELEGIBILIDADE_RENOVABIO_ELEGIVEL_PR_2024',
                        nome: 'CARs Elegíveis - RS',
                        label: 'CARs Elegíveis - RS',
                        layerName: 'vega-api:elegibilidade_renovabio_elegivel_pr_2024',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#9ef42f',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'ELEGIBILIDADE_RENOVABIO_NAO_ELEGIVEL_PR_2024',
                        nome: 'CARs Inelegíveis - RS',
                        label: 'CARs Inelegíveis - RS',
                        layerName: 'vega-api:elegibilidade_renovabio_nao_elegivel_pr_2024',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#f45f2f',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'ELEGIBILIDADE_RENOVABIO_ELEGIVEL_GO',
                        nome: 'CARs Elegíveis - GO',
                        label: 'CARs Elegíveis - GO',
                        layerName: 'vega-api:elegibilidade_renovabio_elegivel_go',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#9ef42f',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'ELEGIBILIDADE_RENOVABIO_NAO_ELEGIVEL_GO',
                        nome: 'CARs Inelegíveis - GO',
                        label: 'CARs Inelegíveis - GO',
                        layerName: 'vega-api:elegibilidade_renovabio_nao_elegivel_go',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#f45f2f',
                        opacidade: 100,
                        inspecionar: true
                    }
                ]
            },
            {
                codigo: 'DESMATAMENTO_2008',
                nome: 'DESMATAMENTO_2008',
                label: 'Desmatamento 2008',
                layerName: 'vega-api:desmatamento_2008',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#ff0000',
                opacidade: 100,
                inspecionar: false
            },
            {
                codigo: 'DESMATAMENTO_2023',
                nome: 'DESMATAMENTO_2023',
                label: 'Desmatamento 2023',
                layerName: 'vega-api:desmatamento_2023',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#ff0000',
                opacidade: 100,
                inspecionar: false
            }
        ]
    },
    {
        label: 'Territórios',
        chaveTraducao: 'territorios',
        icon: 'mdi mdi-folder-outline',
        checkbox: false,
        id: 11,
        children: [
            {
                codigo: 'FINCAS_PARAGUAI',
                nome: 'Fincas Paraguai',
                label: 'Fincas Paraguai',
                checkbox: true,
                layerName: 'lyra-v1-production:fincas_paraguai',
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/lyra-v1-production/wms',
                colorIcon: '#FFF002',
                opacidade: 100,
                inspecionar: false
            }
        ]
    },
    {
        label: 'Limites territoriais',
        chaveTraducao: 'limitesAdministrativos',
        icon: 'mdi mdi-folder-outline',
        checkbox: false,
        id: 12,
        children: [
            {
                codigo: 'EUA_LOCALIDADE_NIVEL_2',
                nome: 'Estados Unidos (Condados)',
                label: 'Estados Unidos (Condados)',
                layerName: 'vega-api:eua_localidade_nivel_2',
                checkbox: true,
                colorIcon: '#02fab0',
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/gwc/service/wms',
                opacidade: 100,
                inspecionar: true
            },
            {
                codigo: 'EUA_LOCALIDADE_NIVEL_1',
                nome: 'Estados Unidos (Estados)',
                label: 'Estados Unidos (Estados)',
                layerName: 'vega-api:eua_localidade_nivel_1',
                checkbox: true,
                colorIcon: '#02fab0',
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/gwc/service/wms',
                opacidade: 100,
                inspecionar: true
            }
            // {
            //     codigo: 'CA_LOCALIDADE_NIVEL_1',
            //     nome: 'Canadá (Províncias/Territórios)',
            //     label: 'Canadá (Províncias/Territórios)',
            //     layerName: 'gs-homolog:canada_localidade_nivel_1',
            //     checkbox: true,
            //     colorIcon: '#13d69c',
            //     ativo: false,
            //     path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
            //     opacidade: 100,
            //     inspecionar: true
            // },
        ]
    }
];

export default camadas;
